const KEY_LAST_COMPANY_CODE = 'lastCompanyCode';
const KEY_LAST_COMPANY_NAME = 'lastCompanyName';
const KEY_LAST_EMAIL = 'lastEmail';
const KEY_REMEMBER_EMAIL = 'rememberEmail';
const KEY_LAST_LOGIN_DATE = 'lastLoginDate';

export interface LoginPreferences {
  lastCompanyCode: string | null;
  lastCompanyName: string | null;
  lastEmail: string | null;
  rememberEmail: boolean;
  lastLoginDate: number | null;
}

export const loadLoginPreferences = (): LoginPreferences => {
  try {
    if (typeof window === 'undefined') {
      return { lastCompanyCode: null, lastCompanyName: null, lastEmail: null, rememberEmail: false, lastLoginDate: null };
    }
    const code = localStorage.getItem(KEY_LAST_COMPANY_CODE);
    const name = localStorage.getItem(KEY_LAST_COMPANY_NAME);
    const email = localStorage.getItem(KEY_LAST_EMAIL);
    const remember = localStorage.getItem(KEY_REMEMBER_EMAIL);
    const lastLogin = localStorage.getItem(KEY_LAST_LOGIN_DATE);
    return {
      lastCompanyCode: code,
      lastCompanyName: name,
      lastEmail: remember === 'true' ? email : null,
      rememberEmail: remember === 'true',
      lastLoginDate: lastLogin ? parseInt(lastLogin, 10) : null,
    };
  } catch {
    return {
      lastCompanyCode: null,
      lastCompanyName: null,
      lastEmail: null,
      rememberEmail: false,
      lastLoginDate: null,
    };
  }
};

export const saveLoginPreferences = (prefs: {
  companyCode: string;
  companyName: string;
  email?: string;
  rememberEmail?: boolean;
  lastLoginDate?: number;
}): void => {
  try {
    if (typeof window === 'undefined') return;
    localStorage.setItem(KEY_LAST_COMPANY_CODE, prefs.companyCode);
    localStorage.setItem(KEY_LAST_COMPANY_NAME, prefs.companyName);
    if (prefs.rememberEmail && prefs.email) {
      localStorage.setItem(KEY_LAST_EMAIL, prefs.email);
      localStorage.setItem(KEY_REMEMBER_EMAIL, 'true');
    } else {
      localStorage.removeItem(KEY_LAST_EMAIL);
      localStorage.setItem(KEY_REMEMBER_EMAIL, 'false');
    }
    if (prefs.lastLoginDate != null) {
      localStorage.setItem(KEY_LAST_LOGIN_DATE, String(prefs.lastLoginDate));
    }
  } catch (e) {
    console.warn('[LoginPreferences] Failed to save:', e);
  }
};
